// extracted by mini-css-extract-plugin
export default {"statContainer":"styles_statContainer__n03R0","textSection":"styles_textSection__moIBS","statSection":"styles_statSection__3qQvt","stat":"styles_stat__pkKxn"};